import loadable from '@loadable/component'

export default {
    '/:type/points/pay/:id': loadable(() => import('./pointsPay')), // 积分商城兑换页面
    '/:type/points': loadable(() => import('./integralList')), // 积分商城列表
    '/:type/points/product/:id': loadable(() => import('./product')), // 积分商品详情
    '/:type/points/detail': loadable(() => import('./jifenDetailedList')), //收支明细
    '/:type/points/exchange': loadable(() => import('./exchange')), //兑换记录
    '/:type/points/task': loadable(() => import('./task')), //积分任务
    '/:type/points/instructions': loadable(() => import('./Instructions')) //积分商城说明
}
